import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppTokenHandler } from '../../../../common/app-token-handler';
import { DataService } from '../../../../common/data.service';
import { Roles } from '../../../../model/bp-record';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.css']
})
export class AppSidebarComponent implements OnInit,AfterViewInit {
  roles = Roles;

  constructor(private router: Router, private appToken: AppTokenHandler, private hrservice: DataService) { }
  
  ngAfterViewInit(): void {
    const select: any = (el, all = false) => {
      el = el.trim();

      return document.querySelector(el);

    };

    const on: any = (type, el, listener, all = false) => {
      if (all) {
        select(el, all).forEach((e) => e.addEventListener(type, listener));
      } else {
        select(el, all).addEventListener(type, listener);
      }
    };

    if (select(".toggle-sidebar-btn")) {
      on("click", ".toggle-sidebar-btn", function (e) {
        select("body").classList.toggle("toggle-sidebar");
      });
    }
  }
  ngOnInit() {

  }

  userHasRole(roleId: number) {
    let visible: boolean = false;
    if (this.appToken.IsInRole(Roles[roleId])) {
      visible = true;
    }
    return visible;
  }

}
